import * as form from '../form';

export const financialRepossession = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        LenderName: form.text(xitem.LenderName),
        PropertyType: form.radio(xitem.PropertyType),
        PropertyTypeExplain: form.textarea(xitem.PropertyTypeExplain),
        FirstPastDue: form.datecontrol(xitem.FirstPastDue),
        NumberMissed: form.text(xitem.NumberMissed),
        Why: form.textarea(xitem.Why),
        When: form.datecontrol(xitem.When),
        AccountNum: form.text(xitem.AccountNum),
        AccountNumIdk: form.notapplicable(xitem.AccountNumIdk),
        Current: form.branch(xitem.Current),
        WhenResolved: form.datecontrol(xitem.WhenResolved),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        CourtName: form.text(xitem.CourtName),
        CourtNameNotApplicable: form.notapplicable(xitem.CourtNameNotApplicable),
        CourtLocation: form.location(xitem.CourtLocation),
        OrderNum: form.text(xitem.OrderNum),
        OrderNumIdk: form.notapplicable(xitem.OrderNumIdk),
        AmountOwed: form.number(xitem.AmountOwed),
      },
    };
  });
  return {
    HasRepossession: form.branch(data.HasRepossession),
    List: form.collection(items, (data.List || {}).branch),
  };
};
